import { trackLink, trackView } from "~/helpers/trackings";
import { formatValueTrackings, findFilterLabels } from "./helpers";
import { STORE_CODE } from "./constants";

export const categoryView = async (categoryName) => {
    trackView({
        page_name: `${STORE_CODE}:${formatValueTrackings(categoryName)}`,
        page_category_1: STORE_CODE,
        page_category_2: formatValueTrackings(categoryName),
        page_category_10: 'categoria-prodotto',
        page_content_status: 'free' 
    });
}

export const categoryProductCardTrack = async (categoryName, productName) => {
    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(categoryName)}:card-prodotto`,
        event_type: `${formatValueTrackings(productName)}`
    }, null, `CPC @CLICK: ${STORE_CODE}:${formatValueTrackings(categoryName)}:card-prodotto - ${formatValueTrackings(productName)}`)
}

export const categoryNavigationTrack = async (categoryName, pageNumber) => {
    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(categoryName)}:navigazione`,
        event_type: `${pageNumber}`
    }, null, `CNT @CLICK: ${STORE_CODE}:${formatValueTrackings(categoryName)}:navigazione - ${pageNumber}`)
}

export const categoryFiltersApplyTrack = async (categoryName, filterList, filters) => {
    
    const result = findFilterLabels(filters, filterList);

    result ? trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(categoryName)}:filtri`,
        event_type: `applica:${formatValueTrackings(result)}`
    }, null, `CFAT @CLICK: applica:${formatValueTrackings(result)}`) : null
}

export const categoryFiltersDeleteAllTrack = async (categoryName) => {
    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(categoryName)}:filtri`,
        event_type: `cancella-tutti`
    }, null, `CFDA @CLICK: cancella-tutti`)
}

export const categorySortByTrack = async (categoryName, sortingValue) => {
    trackLink({
        event_name: `${STORE_CODE}:${formatValueTrackings(categoryName)}:filtri`,
        event_type: `${formatValueTrackings(sortingValue)}`
    }, null, `CSBT @CLICK: ${formatValueTrackings(sortingValue)}`)
}